import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { openConsentManager } from '@segment/consent-manager';
import inEU from '@segment/in-eu';
import { withTranslation } from '../src/i18n';
import { TP } from '../constants/consts';
import Layout, { LayoutContent } from '../components/Layout';
import ParseHtml from '../components/ParseHtml';
import route from '../constants/routes';

const Cookpol = ({ t }) => {
  const [showCookieSettings, setCookieSettings] = React.useState(true);
  // useEffect(() => {
  //   setCookieSettings(inEU());
  // }, []);

  return (
    <>
      <Layout
        customBreadcrumbs={[
          { path: route.HOME, title: `${TP}.m_HOME` },
          { path: route.COOKIE_POLICY, title: `translation:${TP}.FN_CPOL` },
        ]}
      >
        <LayoutContent>
          {t(`${TP}.FN_CPOL`)}
          <ParseHtml>{t(`cookpol:${TP}.TEXT_COOKIE`)}</ParseHtml>
          {showCookieSettings && (
            <a style={{ cursor: 'pointer' }} onClick={openConsentManager}>
              {t(`${TP}.Manage_Settings`)}
            </a>
          )}
        </LayoutContent>
      </Layout>
    </>
  );
};

Cookpol.getInitialProps = async () => ({
  namespacesRequired: ['translation', 'cookpol'],
});

Cookpol.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('translation')(Cookpol);
